
namespace RioERP.Masters {
    export class StatesColumns {
        static columnsKey = 'Masters.States';
    }
}